/** One card of the mocked supplies surface. Its own file, as the
 *  one-component-per-file rule has it. */
import { EM_DASH, SKELETON_KEYS, cardHeading } from './supplies-mock';

export function AuditCard() {
  return (
    <section className="nb-card" style={{ flex: '0 0 auto' }}>
      <div className="nb-card-hd">
        <h3 className="nb-display" style={cardHeading}>
          May Inventory Audit
        </h3>
        <span style={{ fontSize: 11, color: 'var(--nb-subtle)' }}>{EM_DASH} submitted</span>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 8 }}>
        {SKELETON_KEYS.map((k) => (
          <div
            key={k}
            style={{
              padding: '10px',
              background: 'var(--nb-surface)',
              border: '1px solid var(--nb-border)',
              borderRadius: 8,
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginBottom: 6,
                color: 'var(--nb-subtle)',
                fontSize: 12,
                fontWeight: 700,
              }}
            >
              <span>{EM_DASH}</span>
              <span>{EM_DASH}</span>
            </div>
            <div style={{ fontSize: 11, color: 'var(--nb-subtle)' }}>{EM_DASH}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
